import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color", "width", "title"];
import React from 'react';
import Svg from '../Svg';

var ErrorLineSmall = function ErrorLineSmall(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#4C5165' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1.6rem' : _ref$width,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Error icon' : _ref$title,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Svg, _extends({
    title: title,
    width: width,
    viewBox: "0 0 16 16",
    fill: "none"
  }, rest), /*#__PURE__*/React.createElement("path", {
    d: "M7.40816 1.83595C7.66989 1.38802 8.33011 1.38802 8.59184 1.83595L15.4084 13.5024C15.6626 13.9374 15.3511 14.5 14.8166 14.5H1.18343C0.648907 14.5 0.337438 13.9374 0.591596 13.5024L7.40816 1.83595Z",
    stroke: color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 6C8.27614 6 8.5 6.24421 8.5 6.54545L8.5 9.27273C8.5 9.57397 8.27614 9.81818 8 9.81818C7.72386 9.81818 7.5 9.57397 7.5 9.27273L7.5 6.54545C7.5 6.24421 7.72386 6 8 6Z",
    fill: color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 11.5C8.5 11.8012 8.27614 12 8 12C7.72386 12 7.5 11.8012 7.5 11.5C7.5 11.1988 7.72386 11 8 11C8.27614 11 8.5 11.1988 8.5 11.5Z",
    fill: color
  }));
};

export default ErrorLineSmall;